import firebase from 'firebase';
import { useAtom } from 'jotai';
import { useCollectionData } from 'react-firebase-hooks/firestore';
import { db } from './firebase';
import { userRecordAtom, classListAtom } from '../state/atoms';
import { FIRESTORE_FIELDS, FIRESTORE_KEYS } from '../utils/constants';


export default function useClassService() {
  const [user] = useAtom(userRecordAtom);
  const [, setSchoolClassList] = useAtom(classListAtom);
  const {SCHOOL} = FIRESTORE_FIELDS
  const {CLASSES} = FIRESTORE_KEYS

  const useGetClasses = () => {
    const [classList] = useCollectionData(
      firebase.firestore().collection(CLASSES).where(SCHOOL.ID, '==', user?.school?.id),
      { idField: 'id' }
    );
    return { classList };
  };
  const getClasses = async () => {
    try {
      const classesSnapshot = await db.collection(CLASSES).where(SCHOOL.ID, '==', user?.school?.id).get();

      const classes = classesSnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setSchoolClassList(classes);

      return classes;
    } catch (error) {
      console.error('Error fetching classes:', error);
      return [];
    }
  };
  const createClass = (data) => db.collection(CLASSES).add(data);

  const updateClass = (docId, data) => db.collection(CLASSES).doc(docId).update(data);

  const deleteClass = (id) => db.collection(CLASSES).doc(id).delete();

  return { useGetClasses, getClasses, createClass, updateClass, deleteClass };
}
